import Binding from './Binding.vue'

export default Binding
